<template>
  <div class="content">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-01.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Construction</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-26.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-02.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Removal</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-28.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-05.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Electrical</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-29.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-03.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Furniture Assembly</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-30.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-08.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Mobile Barbers</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-31.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-07.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Deliveries</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-01.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-14.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Cleaning</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-33.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-06.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Man and Van</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-34.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-11.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Nail Technicians</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-35.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-13.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Shop & Deliver</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-32.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-15.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Car Transport</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-37.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-12.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Hairdressers</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-38.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-04.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Computer Service</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-39.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-10.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Plumbing</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-40.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-16.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Carpentry</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-41.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-09.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Interior</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-42.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="category card wow fadeInUp" data-wow-delay="0.3s">
            <div class="card-body">
              <div
                class="feature-icon d-flex justify-content-center align-items-center mb-2"
              >
                <span
                  class="rounded-pill d-flex justify-content-center align-items-center p-3"
                >
                  <img
                    src="@/assets/img/icons/category-17.svg"
                    class="img-fluid"
                    alt="logo"
                  />
                </span>
              </div>
              <h5 class="text-center">Car Wash</h5>
              <div class="overlay">
                <img
                  src="@/assets/img/services/service-43.jpg"
                  class="img-fluid"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
